// Head tags are now rendered by <RouteSEO /> from the backend; these stay as no-ops so page imports keep working.
export default function SEO() {
  return null;
}

export function ProfileSEO() {
  return null;
}

export function JobSEO() {
  return null;
}
